import cn from 'classnames';
import React from 'react';
import FadingScrollBars from 'components/FadingScrollBars';
import { selectorBlock as block } from '../../utils';
import { useClipSelect } from '../ClipSelectContext';
import AudioClipSuggestionPreviewCard from './AudioClipSuggestionPreviewCard';

export interface ClipSelectorProps {
  className?: string;
}

const ClipSelector: React.FC<ClipSelectorProps> = ({ className }) => {
  const { visibleSuggestionIds } = useClipSelect();

  return (
    <FadingScrollBars className={cn('clip-select-page__grid-bg', className)}>
      <div className={block('grid-container')}>
        {visibleSuggestionIds?.map(id => (
          <AudioClipSuggestionPreviewCard clipId={id} key={id} />
        ))}
      </div>
    </FadingScrollBars>
  );
};

export default ClipSelector;
